import { render, staticRenderFns } from "./ReplyExistingChildSupport.vue?vue&type=template&id=adad020a"
import script from "./ReplyExistingChildSupport.vue?vue&type=script&lang=ts"
export * from "./ReplyExistingChildSupport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports